import { showToast, showModerationToast } from '../Components/Toast/toast';
import {
  getModerationMessage,
  isContentModerationBlocked,
} from './contentModeration';

export function showErrorToast(error) {
  if (isContentModerationBlocked(error)) {
    showModerationToast(getModerationMessage(error));
    return;
  }

  if (error?.errors && typeof error?.errors === 'object') {
    for (const [, value] of Object.entries(error.errors)) {
      if (Array.isArray(value)) {
        value.forEach((err) => {
          showToast(err, 'error');
        });
      } else {
        showToast(value, 'error');
      }
    }
  } else {
    const message =
      error?.message ||
      (typeof error === 'string' ? error : 'Something went wrong. Please try again.');
    showToast(message, 'error');
  }
}
